import { createIcons, ChevronLeft, ChevronRight, ExternalLink, FileText } from 'lucide';

(function (Drupal) {
  Drupal.behaviors.lucideIcons = {
    attach(context) {
      createIcons({
        icons: {
          ChevronLeft,
          ChevronRight,
          ExternalLink,
          FileText,
        }
      });
    }
  };
})(Drupal);
